export default class Validator {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {
        return !!(value.match(/^(([15][0-8])|([267][0-7])|([34][0-9])|([89][0-6]))[0-9]{3}$/));
    }
}
